import React from "react";
import { Box, Input as ChakraInput, InputProps as ChakraInputProps, Text } from "@chakra-ui/react";
import { FieldError } from "react-hook-form";
import { Label } from "../Label";

interface InputProps extends ChakraInputProps {
  label?: string;
  error?: FieldError;
  disabled?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, disabled, ...rest }, ref) => {
    return (
      <Box flex={1} w={"100%"}>
        {!!label && <Label>{label}</Label>}
        <ChakraInput disabled={disabled} ref={ref} isInvalid={!!error} {...rest} />
        {!!error && <Text mt={2}>{error.message?.toString()}</Text>}
      </Box>
    );
  }
);
